import {
  Sport,
  Venue,
  LimitedSpots,
  UnlimitedSpots,
  Location as BaseLocation,
  EventDifficultyLevel,
  EventSession as BaseEventSession,
} from '../../../../../../App.types'

export enum EventRegistrationValidationProblem {
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  CANCELLED = 'CANCELLED',
  CUSTOMERGROUP_RESTRICTED = 'CUSTOMERGROUP_RESTRICTED',
  FULLY_BOOKED = 'FULLY_BOOKED',
  INVALID_EVENT = 'INVALID_EVENT',
  IN_PAST = 'IN_PAST',
  MAX_FUTURE_BOOKINGS = 'MAX_FUTURE_BOOKINGS',
  NOT_ACTIVE = 'NOT_ACTIVE',
  REGISTRATION_WINDOW = 'REGISTRATION_WINDOW',
  NOT_BOOKABLE = 'NOT_BOOKABLE',
}

export interface RegistrationState {
  bookable: boolean
  validationProblems: Array<EventRegistrationValidationProblem>
}

export interface EventBookableItem {
  id: string
  venue: Pick<Venue, 'id' | 'name' | 'rating' | 'reviewCount'>
  level?: EventDifficultyLevel
  registrationState: RegistrationState
  location?: Location
  sport: Pick<Sport, 'id' | 'name'>
  eventSessions: Array<EventSession>
}

export interface EventSession extends BaseEventSession {
  availableSpots: Omit<LimitedSpots, 'type'> | Omit<UnlimitedSpots, 'type'>
}

export interface Location extends BaseLocation {
  indoor?: boolean
}
